import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoacheeSettingsController } from 'presentation/page/settings/coachee-settings/coachee-settings.controller';

@Component({
	selector: 'spr-settings-mfa',
	templateUrl: './settings-mfa.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'md:row-span-2',
	},
})
export class SettingsMfaComponent {
	constructor(public controller: CoacheeSettingsController) {}

	public onEnableMfaClick() {
		this.controller.enableMfa();
	}

	public onDisableMfaClick() {
		this.controller.disableMfa();
	}
}
